import { supabase } from "./supabaseClient";

export const shipmentsRepository = {
  listForSale: (tenantId: string, saleId: string) =>
    supabase
      .from("shipments")
      .select("*")
      .eq("sale_id", saleId)
      .eq("tenant_id", tenantId)
      .order("created_at", { ascending: false }),

  listAll: (tenantId: string) =>
    supabase
      .from("shipments")
      .select("*")
      .eq("tenant_id", tenantId)
      .order("created_at", { ascending: false }),
};
